import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Alert,
  AvatarGroup,
  Chip,
  Pagination,
  Stack,
  TablePagination,
  TableSortLabel,
} from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Box } from "@mui/system";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
//import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
//import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';
//import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const PairAddRecordsTable = ({ tableHeadings, rows }: Props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const headCells = Object.entries(tableHeadings);

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <Paper sx={{ pt: 2, boxShadow: "none" }}>
        <TableContainer
          className="receiptsTable"
          //component={Paper}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map(([_, value], index) => (
                  <TableCell key={index} align="left">
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <React.Fragment key={row.cron_id}>
                    <TableRow
                      sx={{
                        "& > *": {
                          borderBottom:
                            "1px solid rgba(224, 224, 224, 1) !important",
                        },
                     
                      }}
                    >
                      {headCells.map(([key], cellIndex) => (
                        <TableCell key={cellIndex} align="left">
                          {key === "fme" ? (
                            <div className="chip-data">
                              <>
                                {/* Display first chip */}
                                <Chip
                                  label={row[key] ? row[key] : "N/A"}
                                  //onClick={handleOpenModal}
                                  sx={{
                                    backgroundColor: "#ffffff",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    borderRadius: "5px",
                                    boxShadow: "1px 1px 2px 1px #00000030",
                                    height: "26px",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    border: "1px solid #ffffff",
                                    "&:hover": {
                                      backgroundColor: "transparent",
                                      color: "#9c27b0", // slightly darker on hover
                                      border: "1px solid #9c27b0",
                                    },
                                  }}
                                />
                              </>
                            </div>
                          ) : key === "date" ? (
                            <> {row[key] ? row[key] : "N/A"}</>
                          ) : key === "fme_income" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}
                                <EuroIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "policy_fme_income" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}
                                <CurrencyPoundIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "manual_fme_income" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}{" "}
                                <AttachMoneyIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "linked" ? (
                            <>
                              <div className="AlertItems">
                                {row[key] === "Yes" ? (
                                  // SUCCESS ALERT
                                  <Alert
                                    icon={
                                      <CheckCircleOutlineIcon
                                        fontSize="inherit"
                                        sx={{ color: "rgba(30, 70, 32, 1)" }}
                                      />
                                    }
                                    severity="success"
                                    sx={{
                                      border:
                                        "1px solid rgba(46, 125, 50, 0.5)",
                                      padding: "0px 5px",
                                      display: "inline-flex",
                                    }}
                                  >
                                    Yes
                                  </Alert>
                                ) : row[key] === "No" ? (
                                  // ERROR ALERT
                                  <Alert
                                    icon={
                                      <ErrorOutlineIcon
                                        fontSize="inherit"
                                        sx={{ color: "rgba(95, 33, 32, 1)" }}
                                      />
                                    }
                                    severity="error"
                                    sx={{
                                      border:
                                        "1px solid rgba(211, 47, 47, 0.5)",
                                      padding: "0px 5px",
                                      display: "inline-flex",
                                    }}
                                  >
                                    No
                                  </Alert>
                                ) : (
                                  // OPTIONAL: WHEN EMPTY → N/A ERROR BOX
                                  
                                <></>
                             
                                )}
                              </div>
                            </>
                          ) : key === "covered" ? (
                            <> {row[key] ? row[key] : "N/A"}</>
                          ) : key === "fme_status" ? (
                            <>
                              <div className="AlertItems">
                                <Alert
                                  icon={
                                    <PaidOutlinedIcon
                                      fontSize="inherit"
                                      sx={{ color: "rgba(30, 70, 32, 1)" }}
                                    />
                                  }
                                  severity="success"
                                  sx={{
                                    border: "1px solid rgba(46, 125, 50, 0.5)",
                                    padding: "0px 5px",
                                    display: "inline-flex",
                                  }}
                                >
                                  {row[key] ? row[key] : "N/A"}
                                </Alert>

                                {/* <Alert
                                icon={<ContrastOutlinedIcon fontSize="inherit" sx={{color:'rgba(30, 70, 32, 1)'}} />}
                                severity="success"
                                sx={{border:'1px solid rgba(46, 125, 50, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                               <Alert
                                icon={<PendingOutlinedIcon fontSize="inherit" sx={{color:'rgba(1, 67, 97, 1)'}} />}
                                severity="info"
                                sx={{border:'1px solid rgba(33, 150, 243, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>
                              
                               <Alert
                                icon={<RecommendOutlinedIcon fontSize="inherit" sx={{color:'rgba(1, 67, 97, 1)'}} />}
                                severity="info"
                                sx={{border:'1px solid rgba(33, 150, 243, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>*/}
                              </div>
                            </>
                          ) : key === "account" ? (
                            <> {row[key] ? row[key] : "N/A"}</>
                          ) : key === "brands" ? (
                            <div className="chip-data">
                              {Array.isArray(row?.brands) &&
                                row.brands.length > 0 && (
                                  <>
                                    {/* Display first chip */}
                                    <Chip
                                      label={row.brands[0]}
                                      sx={{
                                        backgroundColor: "#7B1FA2",
                                        color: "#ffffff",
                                        height: "26px",
                                      }}
                                    />
                                    {/* Display second chip if available */}
                                    {row.brands.length > 1 && (
                                      <Chip
                                        label={row.brands[1]}
                                        sx={{
                                          backgroundColor: "#7B1FA2",
                                          color: "#ffffff",
                                          height: "26px",
                                          ml: "1px",
                                        }}
                                      />
                                    )}
                                    {/* AvatarGroup or indicator for remaining items */}
                                    {row.brands.length > 2 && (
                                      <AvatarGroup
                                        total={row.brands.length - 2}
                                      />
                                    )}
                                  </>
                                )}
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
         
        </TableContainer>
         <Stack
            spacing={1}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                  {
                    display: "none",
                  },
                ".MuiTablePagination-actions": {
                  display: "none",
                },
                ".MuiTablePagination-toolbar": {
                  paddingLeft: "16px",
                },
              }}
            />
            <Pagination
              count={Math.ceil(rows?.length / rowsPerPage)}
              page={page + 1}
              showFirstButton
              showLastButton
              className="pagination-button"
              color="secondary"
              size="small"
              sx={{
                ".css-wjh20t-MuiPagination-ul": {
                  justifyContent: "center",
                },
              }}
              onChange={(_, value) => handleChangePage(null, value - 1)}
            />
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              classes={{
                displayedRows: "hidden-displayed-rows", // Apply the custom class
              }}
              sx={{
                ".MuiTablePagination-actions": {
                  display: "none",
                },
                ".MuiTablePagination-input": {
                  marginRight: "15px",
                },
              }}
            />
          </Stack>
      </Paper>
    </>
  );
};

export default PairAddRecordsTable;
